import styled from 'styled-components';
import Button from './index';

const { Group } = Button;
const ButtonGroup = styled(Group)`
  > .ant-btn {
    border-radius: 44px !important;
  }

  /* antd's button-group collapses adjacent borders with a -1px margin, which is
     designed for square segmented controls. Rebranded buttons are pills, so the
     overlap reads as two misaligned shapes. Space them instead. */
  gap: 8px;

  > span + span,
  > span + .ant-btn,
  > .ant-btn + span,
  > .ant-btn + .ant-btn {
    margin-left: 0 !important;
  }
`;
/** @component */
export default ButtonGroup;
